export const REQUESTS_CONFIG = {
   convertedStatuses: ['Client Case', 'Systemic Case', 'I&R', 'Not Converted']
};